import React from 'react'
import { Skeleton } from '@mui/material'
import { FormControl } from '@mui/material'

const AutoFormSkeleton = () => {
  let skeleton = []
  for (let i = 0; i < 16; i++) {
    skeleton.push(<Skeleton variant='rect' height={54} key={'skeleton' + i} />)
  }
  return (
    <FormControl
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '.75rem'
      }}
    >
      {skeleton}
    </FormControl>
  )
}

export default AutoFormSkeleton
